import { t } from '../../../../services/i18nService';
import idVerificationService from '../../../../services/idverification/IdVerificationService';
import livestreamService from '../../../../services/livesession/LivestreamService';
import manualIdVerificationService from '../../../../services/manualidverification/ManualIdVerificationService';
import sessionReader from '../../../../store/readHelpers/SessionReader';

const testComponentManualIdVerificationSelector = {
    selectShouldBeHighlightedAsFailed(isCurrent, isRejected) {
        return isCurrent && isRejected;
    },

    selectShouldNavigateToPhotoRetake(isCurrent, isRetakePhotoStatus, photoRetakeCompleted, livestream) {
        const callingProctor = livestreamService.resolveCallingProctor(livestream);
        return !sessionReader.isPaused() && isCurrent && isRetakePhotoStatus && !photoRetakeCompleted && !callingProctor;
    },

    selectShouldRequestManualIdCheck(isCurrent, isCompleted, isRejected, manualIdVerificationRequestSent) {
        return isCurrent && !isCompleted && !isRejected && !manualIdVerificationRequestSent;
    },

    computeProps(state) {
        const { idverification, livestream } = state;

        const { manualIdVerificationRequestSent, photoRetakeCompleted } = idverification;
        const isCurrent = manualIdVerificationService.isCurrent(idverification);
        const isRejected = manualIdVerificationService.isManualIdVerificationRejected(idverification);
        const isCompleted = manualIdVerificationService.isManualIdVerificationComplete(idverification);
        const isRetakePhotoStatus = idVerificationService.isRequestPhotoRetakeVerificationStatus(idverification);

        return {
            completed: isCompleted,
            current: isCurrent,
            rejected: isRejected,
            shouldBeHighlightedAsFailed: this.selectShouldBeHighlightedAsFailed(isCurrent, isRejected),
            shouldNavigateToPhotoRetake: this.selectShouldNavigateToPhotoRetake(isCurrent, isRetakePhotoStatus, photoRetakeCompleted, livestream),
            shouldRequestManualIdCheck: this.selectShouldRequestManualIdCheck(isCurrent, isCompleted, isRejected, manualIdVerificationRequestSent),
            title: t('manualIdVerification.overview.title'),
        };
    },
};

export default testComponentManualIdVerificationSelector;
